import { SERVICES_ON_FACILITY, SERVICES_ON_FACILITY_SUCCESS, SERVICES_ON_FACILITY_ERROR, SERVICES_ON_FACILITY_EMPTY } from './../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetServiceOnFacility = (state = initialState, action) => {
  switch (action.type) {
    case SERVICES_ON_FACILITY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SERVICES_ON_FACILITY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SERVICES_ON_FACILITY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SERVICES_ON_FACILITY_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetServiceOnFacility;
